/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface ISortTypeTermFieldSchema {
  /** Тип поля **/
  type: EType;
  /** Тип сортировки **/
  value: EValue;
}

export enum EType {
  /** Поле с одним значением **/
  'Term' = 'term',
  /** Поле со списком значений **/
  'Terms' = 'terms',
}
export enum EValue {
  /** Заканчивается срок действия **/
  'AboutToEnd' = 'aboutToEnd',
  /** Новые **/
  'NewFirst' = 'newFirst',
  /** Популярные **/
  'Popularity' = 'popularity',
}
